<template>
  <div
    class="antialiased"
    v-if="
      route.query?.onlyPlayer === 'true' || route.path.includes('/embed/media/')
    "
  >
    <NuxtPage />
  </div>
  <div class="antialiased" v-else>
    <NavigationMenu />
    <NuxtLoadingIndicator :height="8" color="rgba(242, 98, 36, 1)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <NavigationFooter />
    <MediaPlayer
      class="pointer-events-none fixed right-0 bottom-0 z-20 w-full"
    />
  </div>
</template>
<script lang="ts" setup>
const route = useRoute()
</script>
